import axios from "axios";
import { useEffect, useState } from "react";
import "./PushEmail.css";

// const BASE_URL = "http://localhost:8000";
const BASE_URL = "https://idealpursuits.co.in/api";

const PushEmail = () => {
    const [users, setUsers] = useState([]);
    const [selectedEmails, setSelectedEmails] = useState([]);
    const [title, setTitle] = useState("");
    const [body, setBody] = useState("");
    const [statusMessage, setStatusMessage] = useState("");
    const [isSending, setIsSending] = useState(false);

    useEffect(() => {
        axios
            .get(`${BASE_URL}/getUsers.php`)
            .then((response) => {
                const userList = response.data || [];
                setUsers(userList);
                setSelectedEmails(userList.map((user) => user.email));
            })
            .catch((error) => {
                console.error("Error fetching users:", error);
            });
    }, []);

    // Handle checkbox selection
    const toggleUserSelection = (email) => {
        setSelectedEmails((prevSelected) =>
            prevSelected.includes(email)
                ? prevSelected.filter((selected) => selected !== email)
                : [...prevSelected, email]
        );
    };

    // Handle form submission
    const handleSendEmail = async (e) => {
        e.preventDefault();

        if (!title || !body) {
            setStatusMessage("Title and body are required.");
            return;
        }

        const confirmed = window.confirm(
            `Are you sure you want to send this email to ${selectedEmails.length} users?`
        );

        if (!confirmed) return;

        setIsSending(true);
        setStatusMessage("Sending emails...");

        try {
            const response = await axios.post(`${BASE_URL}/sendBulkEmail.php`, {
                title,
                body,
                emails: selectedEmails,
            });
            setStatusMessage(response.data.message || "Emails sent successfully!");
        } catch (error) {
            setStatusMessage("Failed to send emails.");
            console.error("Error:", error);
        } finally {
            setIsSending(false);
        }
    };

    return (
        <div className="push-email-container">
            <h2>Send Email to Users</h2>
            <form onSubmit={handleSendEmail}>
                <div className="form-group">
                    <label>Email Title</label>
                    <input
                        type="text"
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                        placeholder="Enter email title"
                        required
                    />
                </div>
                <div className="form-group">
                    <label>Email Body</label>
                    <textarea
                        value={body}
                        onChange={(e) => setBody(e.target.value)}
                        placeholder="Enter email body"
                        required
                    />
                </div>
                <div
                    style={{
                        maxHeight: "200px",
                        overflowY: "auto",
                        padding: "5px",
                        border: "1px solid #ddd",
                        borderRadius: "4px",
                    }}
                >
                    {users.map((user) => (
                        <label
                            key={user.userId}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "5px",
                                fontWeight: "100",
                                fontSize: "14px",
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={selectedEmails.includes(user.email)}
                                onChange={() => toggleUserSelection(user.email)}
                            />
                            {user.name} ({user.email})
                        </label>
                    ))}
                </div>
                <button type="submit" disabled={isSending}>
                    {isSending ? "Sending..." : "Send Email"}
                </button>
            </form>
            {statusMessage && <p className="status-message">{statusMessage}</p>}
        </div>
    );
};

export default PushEmail;
